<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5 1V9" stroke="#44454E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M1 5H9" stroke="#44454E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
